export default __webpack_public_path__ + "assets/images/event-UK-logo-vecture.svg";